/**
 * @sort id
 * @sort internal_code
 * @sort alias_name
 * @sort name
 */
export default [
    {
        text: "#",
        value: "id",
        sortable: true,
        width: "5%",
    },
    {
        text: "código interno",
        value: "internal_code",
        sortable: true,
        width: "15%"
    },
    {
        text: "alias",
        value: "alias_name",
        sortable: true,
    },
    {
        text: "nombre",
        value: "name",
        sortable: true,
        component: {
            custom: 'id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'product-update',
                        params: {
                            id: value,
                        },
                    }),
                tooltip: 'Detalle del producto',
            },
        },
    },
    {
        text: "stock actual",
        value: "actual_stock",
        align: "center",
        format: "number",
    },
    {
        text: "stock critico",
        value: "branch_offices_critical_stock",
        align: "center",
        format: "number",
    },
    {
        text: "stock máximo",
        value: "branch_offices_maximum_stock",
        align: "center",
        format: "number",
    },
    {
        text: "stock mínimo",
        value: "branch_offices_minimum_stock",
        align: "center",
        format: "number",
    },
]